var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": $t("bxzu1h4", "导入历史"),
      "mask-closable": false,
      "width": "800"
    },
    on: {
      "on-cancel": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('pro-table', _vm._b({
    ref: "proTable"
  }, 'pro-table', _vm.config, false)), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };